<script>
	import { connected } from "../store.js";
    import { getContext } from "svelte"
	import Menu from "../components/Menu.svelte";
    import Loading from "../components/Loading.svelte";

    import {
        Alert,
        Col,
        Container,
        Row,
    } from "sveltestrap"

    export let id;
    export let token;
    let VerifEmailVar;
    let result;
    
    let apiUrl = getContext("apiUrl");

    async function VerifEmail(){
        const fetchLogout = await fetch(apiUrl + "verifEmail.php?id=" + id + "&token=" + token);
        const data = await fetchLogout.json();
        result = data;
    }

    VerifEmailVar = VerifEmail();
</script>



{#key $connected}
    {#if $connected}
        <Menu />
    {/if}
{/key}
<Container>
    <Row>
        <Col lg="2"></Col>
        <Col lg="8">
            {#await VerifEmailVar}
                <Loading />
            {:then}
                {#key result}
                    {#if result.success}
                        <Alert color="success">{result.success}</Alert>
                    {:else if result.error}
                        <Alert color="danger">{result.error}</Alert>
                    {/if}
                {/key}
            {/await}
        </Col>
        <Col lg="2"></Col>
    </Row>
</Container>